import React from "react";

import classNames from "classnames";

import DownloadButton from "./DownloadButton";
import { useGamesContext } from "../contexts/Games";

import SelectItemsPerPage from "../../../../components/SelectItemsPerPage";
import { selectSite } from "../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";

const FiltersSubRow = (): React.JSX.Element => {
    const { site: siteId } = useGamesContext();
    const site = useAppSelector(state => selectSite(state, siteId));

    return (
        <div className={classNames("filterSubRow")}>
            <SelectItemsPerPage />
            <DownloadButton site={site?.displayName} />
        </div>
    );
};

export default FiltersSubRow;
